import {Booking} from '../../types/Booking';

const BuyerBookingTabs = Object.freeze({
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
} as const);

type BuyerBookingTab = typeof BuyerBookingTabs[keyof typeof BuyerBookingTabs];

interface BuyerBookingTabVerbiageEntry {
  label: string;
  title?: string;
  status?: string;
  paymentActionLabel?: string;
}

const BuyerBookingTabVerbiage: Readonly<Record<BuyerBookingTab, BuyerBookingTabVerbiageEntry>> = Object.freeze({
  [BuyerBookingTabs.ACTIVE]: {
    label: 'Active',
  },
  [BuyerBookingTabs.INACTIVE]: {
    label: 'Inactive',
    title: 'A booking that is expired, canceled, or declined.',
    status: 'Inactive',
    paymentActionLabel: 'Update Payment Method',
  },
  [BuyerBookingTabs.PENDING]: {
    label: 'Pending',
  },
  [BuyerBookingTabs.PAYMENT_FAILED]: {
    label: 'Payment Failed',
    title: 'A booking that has failed due to insufficient funds or a bank dispute. The booking cannot be used until the buyer submits payment.',
    status: 'Payment Denied',
    paymentActionLabel: 'Make Payment',
  },
});

interface HeaderCell {
  id: string;
  label: string;
}

const headerCells: HeaderCell[] = [
  { id: 'orderNumber', label: 'BOOKING NUMBER' },
  { id: 'frequencyValue', label: 'FREQUENCY' },
  { id: 'bookedDates', label: 'BOOKED DATES' },
  { id: 'locationName', label: 'LOCATION' },
  { id: 'recurringCharge', label: 'MONTHLY CHARGE' },
  { id: 'status', label: 'STATUS' },
  { id: 'supplierCompanyName', label: 'SUPPLIER' },
  { id: 'numberOfSpaces', label: 'SPACES BOOKED' },
  { id: 'paymentSchedule', label: 'PAYMENT SCHEDULE' },
  { id: 'initialCharge', label: 'INITIAL CHARGE' },
  { id: 'paymentMethodDescription', label: 'PAYMENT METHOD' },
  { id: 'assetType', label: 'EQUIPMENT TYPE' },
  { id: 'creationDate', label: 'CREATED ON' },
  { id: 'rate', label: 'RATE' },
  { id: 'overageRate', label: 'OVERAGE RATE' },
];

// Mutates the booking in place; buyerBookingTab is a client-side field not present on the Booking model
const setBuyerBookingTab = (booking: Pick<Booking, 'active' | 'status'> & {buyerBookingTab?: BuyerBookingTab}) =>  {
  if (booking.active) {
    booking.buyerBookingTab = BuyerBookingTabs.ACTIVE;
  } else if (booking.status === "Pending" || booking.status === "Incomplete") {
    booking.buyerBookingTab = BuyerBookingTabs.PENDING;
  } else if (booking.status === 'Payment Declined') {
    booking.buyerBookingTab = BuyerBookingTabs.PAYMENT_FAILED;
  } else {
    booking.buyerBookingTab = BuyerBookingTabs.INACTIVE;
  }
};

export {
  BuyerBookingTabs,
  BuyerBookingTabVerbiage,
  headerCells,
  setBuyerBookingTab
}

export type { BuyerBookingTab, HeaderCell }